import React, {useState, useCallback} from "react";
import GenericTemplate from "../../../templates/GenericTemplate";
import {
  apollo_useStyles,
  options_mimetype, options_mimetype_zeus
} from "../../../atom/Apollo_styles";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloPageUsagePermission} from "../../../atom/Apollo_Authorization";
import {
  advertisementedit_path,
  crassets_path,
  get_zeus_resources_images_path,
  zeus_ad_account,
  post_zeus_resources_path,
  get_zeus_resources_path,
  advertisements_path,
} from "../../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../../atom/Apollo_Context";
import { LogData, ApolloEventRecord } from "../../../atom/Apollo_EventRecord";
import {CrAssetZipZeus} from "./CrAssetModel";
import CrAssetZipFormZeus from "./CrAssetZipFormZeus";
import {DataTableOptions, ApolloDataTable} from "../../../atom/Apollo_DataTable";
import {
  valueToLabel,
  checkInvalidCharForName,
  checkInvalidCharForImageFileName,
  validateImage
} from "../../../common/Apollo_CommonUtil";
import {ApolloRightDrawerContext} from "../../../molecule/Apollo_RightDrawer";
import {ApolloTabPanel, ApolloTabs2} from "../../../atom/Apollo_Tabs"
import {ApiResponse, ApolloAxios, getResultType, isSuccessApi} from "../../../atom/Apollo_ApiRequest3";

import axios from "axios"
import moment from 'moment'
import {useHistory, useLocation, useParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";

import Button from "@material-ui/core/Button";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Typography from "@material-ui/core/Typography";

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import IconButton from "@material-ui/core/IconButton"

import {useDropzone} from 'react-dropzone'
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";

const animatedComponents = makeAnimated();
const DATE_TIME_SUFFIX = "Z"
const BLANK = ""

/**
 * base64をBlob(csv)に変換する
 * @param {string} base64 - base64文字列
 * @returns {Blob} base64をBlob(csv)に変換した値
 */
const convertBlob = (base64: string): Blob => {
  var bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);
  const bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);

  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }

  return new Blob([bom, buffer.buffer], {type: 'text/csv'});
}

const CrAssetEditImage: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const handelGoback = () => {
    // Zeus広告編集戻る際のエラー暫定対応
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
    setmsg({
      type: "setMessage",
      payload: {
        ...data,
        open: false,
        type: "",
        message: "",
      }
    });
    history.goBack();
  };

  const reader = new FileReader();

  const {data, setmsg} = React.useContext(ApolloMessage);
  const {state} = React.useContext(ApolloContext);
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);
  const [imageFiles, setImageFiles] = useState("");
  const [dataURI, setDataURI] = useState("");
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageMimeType, setImageMimeType] = useState(options_mimetype_zeus[0]);
  const [errorMessages, setErrorMessages] = useState("");
  const [zeusAccountName, setZeusAccountName] = useState("");
  const [tabstate, setTabstate] = useState(0);
  const [uploadedMsg, setUploadedMsg] = useState("");
  const [uploadedResultCsv, setUploadedResultCsv] = useState<any>()
  const [crAssetZip, setCrAssetZip] = useState<CrAssetZipZeus>({
    attachment: "",
  });
  const [table, setTable] = useState<any>([]);

  const {accountgroupid, accountid, platformaccountid} = useParams<{accountgroupid: string; accountid: string; platformaccountid: string }>();
  const reqParams = new URLSearchParams(useLocation().search);
  const campaignId = reqParams.get("campaignId") ?? "0";
  const adGroupId = reqParams.get("adGroupId") ?? "0";
  const adId = reqParams.get("adId") ?? "0";

  const {register, handleSubmit, errors, control, formState} = useForm();
  const valueToOption = function (value: any, options: Array<{ value: any; label: string }>): { value: any; label: string } | null {
    let option = options?.find(option => option.value === value)
    if (!option) {
      return null
    } else {
      return option
    }
  }

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 16,
    breadId: 2,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  const urlParams = new URLSearchParams(useLocation().search);

  React.useEffect(() => {
    const url = process.env.REACT_APP_API_ENDPOINT + zeus_ad_account + platformaccountid;
    axios.get(url,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        },
      }).then((response) => {
        setZeusAccountName((response.data).name);
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "zeusアカウント名の取得に失敗しました"
          }
        });
      });

    urlParams.has("type") && urlParams.get("type") === "mu"
      ? setTabstate(1)
      : setTabstate(0)

    // 一括アップトード結果取得
    getAdResourcesZip();
  }, []);

  const onSubmit = handleSubmit(async (formData: any) => {

    if (!imageFiles[0]) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルを選択してください"
        }
      });
      return
    }

    if (acceptedFiles[0].type !== (formData.mimeTypeId).label) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "選択したMIME種別とアップロードファイルの形式が異なります。アップロードファイルと同じMIME種別を選択してください"
        }
      });
      return
    }

    if (errorMessages) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errorMessages
        }
      });
      return
    }

    var executeLogData: LogData = {
      eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute", // ログ種別 実行：execute, 結果：result
      result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      displayName: "Zeusクリエイティブアセット編集画面",
      category: "広告アセット", // 操作対象 キャンペーン / セグメント etc...
      actionType: "作成",
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      targetID: "", // 操作を行うデータのID 実行時は空文字
      targetName: "", // 操作を行うデータの名称 実行時は空文字
      menu: "パフォーマンス広告",
      itemList: [
        {key:"MIME種別", beforeValue:"", afterValue: valueToOption((formData.mimeTypeId).value, options_mimetype)?.label ?? ""},
        {key:"ファイル名", beforeValue:"", afterValue: acceptedFiles[0].name},
      ]
    };
    ApolloEventRecord(executeLogData);

    const url = process.env.REACT_APP_API_ENDPOINT + get_zeus_resources_images_path;

    const params = new FormData();
    params.append('adAccountId', platformaccountid);
    params.append('mimeTypeId', (formData.mimeTypeId).value);
    params.append('width', formData.width);
    params.append('height', formData.height);
    params.append('fileName', acceptedFiles[0].name);
    params.append('reviewStatus', '2');
    params.append('file', imageFiles[0]);

    //APIコール
    await axios.post(
      url,
      params,
      {
        headers: {
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      })
      .then((response) => {
        executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
        executeLogData.logType = "result";
        executeLogData.result = "成功";
        ApolloEventRecord(executeLogData);

        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "success",
            message: "広告アセット(画像)の新規作成に成功しました"
          }
        });

        if(reqParams.get("campaignId") === "0" && reqParams.get("adGroupId") === "0" && reqParams.get("adId") === "0"){
          history.push(`${advertisementedit_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${campaignId}&adGroupId=${adGroupId}`);
          return
        }

        if(campaignId !== "0" && adGroupId !== "0" || campaignId !== "0") {
          if(adId === "0"){
            history.push(`${advertisementedit_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${campaignId}&adGroupId=${adGroupId}`);
            return
          }
          setDrawerState({
            type: 'close',
            payload: {
              ...drawerState,
              open: false,
            }
          })
          history.push(`${advertisements_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}?campaignId=${campaignId}&adGroupId=${adGroupId}`);
          return;
        }
        history.push(`${crassets_path}zeus/${accountgroupid}/${accountid}/${platformaccountid}`);
      })
      .catch((error) => {
        executeLogData.eventDate = moment().format("YYYY-MM-DD HH:mm:ss");
        executeLogData.logType = "result";
        executeLogData.result = "失敗";
        ApolloEventRecord(executeLogData);
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: error?.response?.data?.message || error?.message,
          }
        });
      })
  });

  const [changeSelect, setChangeSelect] = React.useState(false);

  const onDrop = useCallback((acceptedFiles,fileRejections) => {

    console.log(fileRejections[0]);
    console.log(acceptedFiles[0]);

    setImageFiles(acceptedFiles);
    var datauri = '';


    if (fileRejections[0]?.errors[0].code == 'file-invalid-type') {
      setDataURI(datauri);
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "画像ファイル（png, jpeg, gif）を設定してください。"
        }
      });
      return
    }

    if (fileRejections[0]?.errors[0].code == 'file-too-large') {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルサイズが600KBを越えています。"
        }
      });
      return
    }

    if (!acceptedFiles[0]) {
      setDataURI(datauri);
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "画像のアップロードに失敗しました"
        }
      });
      return
    }

    const fileNameOrigin: string = acceptedFiles[0].name
    const fileNameArray: string[] = fileNameOrigin.split('.')
    fileNameArray.pop()
    const fileName: string = fileNameArray.join(".")

    setChangeSelect(changeSelect);

    switch (acceptedFiles[0].type) {
      case "image/png":
        setImageMimeType(options_mimetype[0]);
        break;
      case "image/jpeg":
        setImageMimeType(options_mimetype[1]);
        break;
      case "image/gif":
        setImageMimeType(options_mimetype[2]);
        break;
      default:
        break;
    }

    setChangeSelect(!changeSelect);

    reader.onload = () => {
      datauri = reader.result as string;
      setDataURI(datauri);

      const img = new Image();
      let errormessage = '';
      setErrorMessages(errormessage);

      img.addEventListener('load', () => {
        let width = img.width;
        let height = img.height;
        setImageWidth(img.width);
        setImageHeight(img.height);
        console.log(width);
        console.log(height);
        const errMsg = validateImage(img.width, img.height);
        if (errMsg) {
          setErrorMessages(errMsg);
          return
        }
        const imgNameErrorMsg = checkInvalidCharForImageFileName(fileName)
        if (imgNameErrorMsg !== "") {
          let localErrorMessage = imgNameErrorMsg
          if (localErrorMessage === "禁止文字が含まれます。") {
            localErrorMessage = "入力不可文字が含まれています。"
          }
          setErrorMessages("画像ファイル名エラー：" + localErrorMessage);
          return
        }
        if (fileNameOrigin.length > 255) {
          setErrorMessages("ファイル名が255文字を超えています");
          return
        }
      });
      img.src = datauri;
    }
    if (acceptedFiles[0]) {
      reader.readAsDataURL(acceptedFiles[0]);
    }

  }, [])

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg, image/gif, image/png',
    maxSize: 600 * 1024,
    onDrop,
  });

  // @ts-ignore
  const files = acceptedFiles?.map(file => (
    file.name
  ));

  /** 一括アップロード */
  const handleSubmit2 = async () => {
    let isSuccess = false;

    var executeLog: LogData = {
      eventDate:  moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute", // ログ種別 実行：execute, 結果：result
      result: "", // 実行結果 成功 / 失敗 ※実行時は空文字
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken,
      displayName: "Zeusクリエイティブアセット編集画面",
      category: "広告アセット一括アップロード", // 操作対象 キャンペーン / セグメント etc...
      actionType: "アップロード",
      accountGroupID: state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID: state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      targetID: "", // 操作を行うデータのID 実行時は空文字
      targetName: "", // 操作を行うデータの名称 実行時は空文字
      menu: "パフォーマンス広告",
      itemList: [
        {key:"ファイル名", beforeValue:"", afterValue: crAssetZip.attachment[0].name},
      ]
    };
    ApolloEventRecord(executeLog);

    const params = new FormData();
    params.append('attachment', crAssetZip.attachment[0]);

    const url = `${process.env.REACT_APP_API_ENDPOINT}${post_zeus_resources_path}/${platformaccountid}/zip`
    await ApolloAxios.post(
      url,
      params,
      {
        timeout: 60000 * 3,
        headers: {}
      },
    ).then(response => {
      isSuccess = true;

      setUploadedMsg(response.data.message);
      setUploadedResultCsv(response.data.csvFile);

      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "success",
          message: "アップロードを受付けました。",
        }
      });
    }).catch(err => {
      let errMsg: string = err.errmsg
      if (errMsg === "request形式不備です。アップロードしたファイルの拡張子とデータ形式が不一致です。") {
        errMsg = "アップロードしたファイルの拡張子とデータ形式が不一致です。"
      }
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: errMsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executeLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess ? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);

      if (isSuccess) {
        setCrAssetZip({
          attachment: "",
        });
        getAdResourcesZip();
      }
    });
  }

  /** アップロード結果ダウンロード */
  const handleDownload = () => {
    const blob = convertBlob(uploadedResultCsv);
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `performance_cr_asset_zip_upload_result_${moment().format("YYYYMMDD")}.csv`;
    link.click();
  }

  /** 一括アップロード結果一覧取得 */
  const getAdResourcesZip = async () => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_path}/${platformaccountid}/zip`
    await axios.get(
      url,
      {
        headers: {
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }
    ).then(response => {
      setTable(response.data ?? []);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: err?.response?.data?.message || err?.message,
        }
      });
    }).finally(() => {
      //
    });
  }

  /** アップロード結果CSVダウンロード */
  const download = async (batchId: string) => {
    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_resources_path}/${batchId}/download`
    await axios.get(
      url,
      {
        headers: {
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }
    ).then(response => {
      const blob = convertBlob(response.data);
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `performance_cr_asset_zip_upload_result_${moment().format("YYYYMMDD")}.csv`;
      link.click();
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: err?.response?.data?.message || err?.message,
        }
      });
    }).finally(() => {
      //
    });
  }

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "batchId",
      label: "一括処理ID",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "uploadDate",
      label: "アップロード日時",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return value
            ? moment(value.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
            : BLANK;
        },
      }
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return valueToLabel(value, [
            {value: 1, label: '正常処理'},
            {value: 2, label: 'エラー'},
          ]);
        },
      }
    },
    {
      name: "endDate",
      label: "処理終了日時",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return value
            ? moment(value.replace(DATE_TIME_SUFFIX, BLANK)).format("YYYY-MM-DD HH:mm:ss")
            : BLANK;
        },
      }
    },
    {
      name: "allNumber",
      label: "全件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "successNumber",
      label: "取り込み成功件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "failedNumber",
      label: "取り込みエラー件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "batchId",
      label: "アップロード結果CSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            <IconButton aria-label="download" onClick={() => download(value)}>
              <CloudDownloadIcon/>
            </IconButton>
          );
        },
      }
    },
  ]

  const sortOrder: MUISortOptions = {
    name: "batchId",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options: DataTableOptions = {
    filter: false,
    download: false,
    print: false,
    search:false,
    sort: false,
    sortOrder: sortOrder,
    viewColumns:false,
    selectableRows: selectableRows,
    pagination:false,
    jumpToPage: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>

        <ApolloTabs2 value={tabstate} setValue={setTabstate} tablabel={["個別アップロード", "一括アップロード", "一括アップロード結果一覧"]}/>

        <ApolloTabPanel value={tabstate} index={0}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    id="adAccountId"
                    name="adAccountId"
                    inputRef={register}
                    label="パフォーマンス広告アカウントID"
                    disabled
                    fullWidth
                    autoComplete="パフォーマンス広告アカウントID"
                    defaultValue={platformaccountid}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="adAccountName"
                    name="adAccountName"
                    inputRef={register}
                    label="パフォーマンス広告アカウント名"
                    disabled
                    fullWidth
                    autoComplete="パフォーマンス広告アカウント名"
                    value={zeusAccountName}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="width"
                    name="width"
                    label="幅（画像選択後自動入力）"
                    variant="filled"
                    fullWidth
                    autoComplete="幅"
                    value={imageWidth}
                    inputProps={{type: 'number'}}
                    inputRef={register}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="height"
                    name="height"
                    label="高さ（画像選択後自動入力）"
                    variant="filled"
                    fullWidth
                    autoComplete="高さ"
                    value={imageHeight}
                    inputProps={{type: 'number'}}
                    inputRef={register}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    id="fileName"
                    name="fileName"
                    label="ファイル名（画像選択後自動入力）"
                    variant="filled"
                    fullWidth
                    autoComplete="ファイル名"
                    value={files}
                    inputProps={{maxLength: 255}}
                    inputRef={register}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom component="div" color="inherit">
                    MIME種別
                  </Typography>
                  <Controller
                    id="mimeTypeId"
                    name="mimeTypeId"
                    as={Select}
                    control={control}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    key={changeSelect ? "Loading" : "Loaded"}
                    defaultValue={imageMimeType}
                    options={options_mimetype_zeus}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom component="div" color="inherit">
                    アップロードファイル
                  </Typography>
                  <Typography variant="body2" gutterBottom component="div" color="textSecondary">
                    【サイズ】最大600KB <br />
                    【ファイル形式】png, jpeg, gif <br />
                    <div style={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                      【幅:高さ】
                      <span>
                        アップロードする画像は、入稿可能な画像サイズの条件を満たす必要があります。
                      </span>
                    </div>
                    <div style={{ marginLeft: "80px" }}>
                      入稿可能な画像サイズの詳細は
                      <a
                        href={process.env.REACT_APP_MANAGEMENT_MANUAL_AD_IMAGE}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        管理画面マニュアル
                      </a>
                      をご確認ください
                    </div>
                  </Typography>
                  <section className="container">
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div className={classes.droparea}>
                        <p className={classes.p}>ここにファイルをドラッグ＆ドロップ<br/>もしくは、クリックして選択</p>
                      </div>
                    </div>
                  </section>
                  <aside style={{marginTop: '1em'}}>
                    <img src={dataURI} style={{width: '40%'}}/>
                  </aside>
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={classes.cardaction}>
              <Button
                type="submit"
                color="primary"
                className={classes.button}
                onClick={onSubmit}
                variant="contained"
                disabled={formState.isSubmitting}
              >
                作成
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
              >
                戻る
              </Button>
            </CardActions>
          </Card>
        </ApolloTabPanel>
        <ApolloTabPanel value={tabstate} index={1}>
          <CrAssetZipFormZeus
            crAssetZipState={{
              crAsset: crAssetZip,
              setCrAsset: setCrAssetZip,
            }}
            uploadedMsgState={{
              uploadedMsg: uploadedMsg,
              setUploadedMsg: setUploadedMsg,
            }}
            downloadAction={handleDownload}
            submitAction={handleSubmit2}
            goBackAction={handelGoback}
          />
        </ApolloTabPanel>
        <ApolloTabPanel value={tabstate} index={2}>
          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              data={table}
              columns={columns}
              options={options}
              title=""
            />
          </Card>
        </ApolloTabPanel>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default CrAssetEditImage;
